export function loadChatBot() {
  if (window.chatbotLoaded) return; // prevent double load

  const chatContainer = document.createElement('div');
  chatContainer.id = 'chatbotContainer';
  document.body.appendChild(chatContainer);

  const link = document.createElement('link');
  link.href = 'https://app.algobulls.com/chatbot.css';
  link.rel = 'stylesheet';
  document.head.appendChild(link);

  const script = document.createElement('script');
  script.src = 'https://app.algobulls.com/chatbot.js';
  script.async = true;
  script.onload = () => {
    window.chatbotLoaded = true;
  };
  document.body.appendChild(script);
}
